import { render, staticRenderFns } from "./Screenshot.vue?vue&type=template&id=b5ecd0bc&scoped=true&"
import script from "./Screenshot.vue?vue&type=script&lang=js&"
export * from "./Screenshot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ecd0bc",
  null
  
)

export default component.exports